<script>
export default {
  name: "HyperLinkReportProyects",
  functional: true,
  props: {
    openDrawer: {
      type: Function
    }
  },

  render(createElement, context) {
    const tableCell = context.data.attrs;
    const cellValue = tableCell.row[tableCell.column];
    let element;
    let Claess = "green";
    switch (tableCell.column) {
      case "Ingresos":
        Claess = "blue";

        break;
      case "Egresos":
        Claess = "blue";
        break;
      case "Margen":
        Claess = "blue";
        break;
      case "IngresosEjecutado":
        Claess = "green";
        break;
      case "EgresosEjecutado":
        Claess = "green";
        break;
      case "MargenEjecutado":
        Claess = "green";
        break;
      default:
        break;
    }
    element = createElement(
      "a",
      {
        attrs: {
          href: "#",
          class: Claess
        },
        on: {
          click: () => {
            if (context.props.openDrawer) {
              context.props.openDrawer(tableCell.row, tableCell.column);
            }
          }
        }
      },
      Number(cellValue).toLocaleString("es-ES", { minimumFractionDigits: 2 })
    );

    if (cellValue !== 0) {
      return element;
    }

    return createElement("span", ""); // Si el valor es 0, retorna un span vacío
  }
};
</script>
